import React, { useEffect, useState } from 'react';
import { Typography, notification, Button, Modal, Table, Tag } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from '../../redux/modules/course';

import DrawerForm from '../../components/basic/drawer';
import WordForm from './components/wordForm';
import { FormattedMessage, useIntl } from 'react-intl';
import 'antd/dist/antd.min.css';
import Common from '../../lib/common';
import CONSTANTS from '../../lib/constants';

const { ACTION_KEY } = CONSTANTS;
const { getAllWord, deleteWord, createWord, updateWord } = actions;
const { Title } = Typography;
const { confirm } = Modal;
const { getPageTitleName } = Common;

interface Pagination {
    current: number
    pageSize: number
    showSizeChanger?: boolean
    total?: number
}
interface DefaultRootState {
    user: {
        userActions: Array<number>
    }
    course: {
        allLesson: Array<any>
        words: Array<any>
    }
}

interface DrawerInfo {
    // isCreate: boolean
    title: any,
    type: string
    initialValues?: any | undefined
}

interface Props {
    courseId: string
}

const WordView = (props: Props) => {
    const [pagination, setPagination] = useState<Pagination>({
        current: 1,
        pageSize: 20,
        showSizeChanger: true,
    });
    const [drawer, setDrawer] = useState<DrawerInfo>({
        // isCreate: true,
        title: '',
        type: '',
    });
    const [visible, setVisible] = useState<boolean>(false);
    const intl: { formatMessage: (id: { id: string }) => string } = useIntl();
    const { words, userActions } = useSelector((state: DefaultRootState) => ({
        words: state.course.words,
        userActions: state.user.userActions,
    }));
    const dispatch = useDispatch();

    // config table title
    const titleData = ['lessonName', 'deleteTip', 'action'];
    const titleName = getPageTitleName(titleData, intl.formatMessage);

    const refreshList = () => {
        dispatch(getAllWord());
    };

    const showDrawer = (item?: { _id: string }) => {
        const data = item && item._id
            ? {
                title: 'Update Word',
                type: 'update',
                visible: true,
                initialValues: item,
            }
            : {
                title: 'Create Word',
                type: 'create',
                visible: true,
            };
        setDrawer(data);
        setVisible(true);
    };

    const deleteList = (id: string) => {
        dispatch(deleteWord(id));
        notification.success({
            message: 'Delete Success',
            description: '删除成功',
            placement: 'topRight',
        });
        refreshList();
    };

    const onClose = () => {
        setDrawer({ ...drawer, initialValues: '' });
        setVisible(false);
    };

    const onSubmit = (values: any) => {
        if (values._id) {
            dispatch(updateWord(values));
        } else {
            dispatch(createWord(values));
        }
        onClose();
        refreshList();
    };

    const setPaginationParams = (paginationInfo: any) => {
        setPagination(paginationInfo);
    };

    const columns = [
        {
            title: '单词',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: '翻译',
            dataIndex: 'analysis',
            key: 'analysis',
            // eslint-disable-next-line react/display-name
            render: (text: {}, formValues: any) => formValues.analysis.map((analyse: { translate: string, _id: string }) => analyse.translate && <Tag key={analyse._id} color='success'>{analyse.translate}</Tag>),
        },
        {
            title: '操作',
            key: 'action',
            fixed: 'right',
            // eslint-disable-next-line react/display-name
            render: (text: {}, formValues: { content: string, _id: string }) =>
                <span>
                    <Button
                        icon={<EditOutlined />}
                        type='text'
                        disabled={!userActions.includes(ACTION_KEY.EDIT)}
                        onClick={() => showDrawer(formValues)}
                    ></Button>
                    <Button
                        icon={<DeleteOutlined />}
                        type='text'
                        disabled={!userActions.includes(ACTION_KEY.DELETE)}
                        onClick={() => {
                            confirm({
                                title: `Are you sure you want to delete ${formValues.content}?`,
                                icon: <ExclamationCircleOutlined />,
                                okType: 'danger',
                                onOk() {
                                    deleteList(formValues._id);
                                },
                            });
                        }}
                    >
                    </Button>
                </span>,
        },
    ];

    useEffect(() => {
        refreshList();
    }, [pagination.current, pagination.pageSize]);
    return (
        <div>
            <Title>Word</Title>
            <Button
                shape='circle'
                size='large'
                icon={<PlusOutlined />}
                onClick={() => showDrawer()}
                type='primary'
                disabled={!userActions.includes(ACTION_KEY.CREATE)}
                className='plusIcon'
            >
            </Button>
            <Table
                rowKey={(data: { _id: string }) => data._id}
                columns={columns as Array<object>}
                dataSource={words as Array<{ _id: string }>}
                pagination={pagination}
                onChange={paginationInfo => setPaginationParams(paginationInfo)}
            />

            {
                visible &&
                <DrawerForm
                    {...drawer}
                    visible
                    onClose={onClose}
                >
                    <WordForm
                        onClose={onClose}
                        initialValues={drawer.initialValues}
                        onSubmit={onSubmit}
                    />
                </DrawerForm>
            }
        </div>
    );
};


export default WordView;
